import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { default as SelectField } from 'material-ui/SelectField'
import { default as MenuItem } from 'material-ui/MenuItem'
import { default as FlatButton } from 'material-ui/FlatButton'
import { default as TextField } from 'material-ui/TextField'
import { default as Dialog } from 'material-ui/Dialog'
import { default as Tab, default as Tabs } from 'material-ui/Tabs'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import ToggleCheckBox from 'material-ui/svg-icons/toggle/check-box';
import ToggleCheckBoxOutlineBlank from 'material-ui/svg-icons/toggle/check-box-outline-blank';

import Checkbox from 'material-ui/Checkbox';

import { closeAddClusterForm, updateField, updateCluster, onBuildingSelect, fetchClusters } from '../../actions/clusters'
import { fetchBuildings } from '../../actions/buildings'
import './AddCluster.css'

import { chunks } from '../../utils/array.js'

class AddCluster extends Component {
  static defaultProps = {
    handleSwitchBuildingChange: false,
    open: false
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(fetchBuildings())
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeAddClusterForm())
  }

  updateCluster() {
    const { dispatch } = this.props
    dispatch(updateCluster(this.props.cluster.name, this.props.cluster._id, this.props.cluster.buildings))
  }

  updateField(event) {
    const { dispatch } = this.props
    dispatch(updateField(event.target.name, event.target.value))
  }

  handleChange(event, index, values) {
    const { dispatch } = this.props
    dispatch(updateField('clusters', values.map((cluster) => this.props.clusters.find((b) => b._id === cluster))))
  }

  onBuildingSelect(building) {
    const { dispatch } = this.props
    dispatch(onBuildingSelect(building._id))
  }

  render() {
    let buildings = this.props.buildings
    let organizedBuildings = chunks(buildings, 2)

    if (this.props.cluster) {
      const actions = [
        <FlatButton label='Cancel' primary={true} onClick={this.closeDialog.bind(this)} />,
        <FlatButton
          label={this.props.cluster._id == null ? 'Add Cluster' : 'Update Cluster'}
          primary={true}
          onClick={this.updateCluster.bind(this)}
        />
      ]

      let selectedBuildings = this.props.cluster.buildings

      return (
        <Dialog actions={actions} title='Add Cluster' modal={true} open={this.props.close == true} autoScrollBodyContent={true}>
          <div>
            <div>
              <TextField
                name='name'
                hintText='Name'
                floatingLabelText='Name'
                value={this.props.cluster.name}
                onChange={this.updateField.bind(this)}
              />

              <Table selectable={false} style={{ tableLayout: 'auto' }} fixedHeader={false}>
                <TableBody displayRowCheckbox={false}>
                {organizedBuildings.map((row) => (
                  <TableRow>
                    {row.map((building) => (
                      <TableRowColumn>
                      <Checkbox
                          label={building.name}
                          checkedIcon={<ToggleCheckBox />}
                          uncheckedIcon={<ToggleCheckBoxOutlineBlank />}
                          checked={this.props.cluster.buildings.indexOf(building._id) > -1}
                          onCheck={this.onBuildingSelect.bind(this, building)}
                        />
                        </TableRowColumn>
                    ))}
                  </TableRow>
                ))}
                </TableBody>
              </Table>
              <br />
            </div>
          </div>
        </Dialog>
      )
    } else {
      return <div />
    }
  }
}

const mapStateToProps = (state) => {
  return state.clustersReducer
}

export default connect(mapStateToProps)(AddCluster)



// WEBPACK FOOTER //
// ./src/components/clusters/AddCluster.js